import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isRouteActive, tabsFor } from '../../navigation/routes';
import { useAuth } from '../../contexts/AuthContext';

export interface PageTabsProps {
  /** id des Sidebar-Eintrags, dessen Reiter (`tabOf`) gezeigt werden. */
  entryId: string;
  label?: string;
}

/**
 * Reiterleiste fuer Sammelseiten (Workflows, Medien): jeder Reiter ist eine
 * eigene Route aus der Registry, die Leiste zeigt nur, dass sie zusammen-
 * gehoeren. Ohne zweiten Reiter wird nichts gerendert.
 */
export const PageTabs: React.FC<PageTabsProps> = ({ entryId, label = 'Bereiche' }) => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  // Reiter ohne Recht bleiben weg (Paket 2), sonst landet der Klick auf "Kein Zugriff".
  const tabs = tabsFor(entryId, user);
  if (tabs.length < 2) return null;
  return (
    <nav className="tabs page-tabs" aria-label={label}>
      {tabs.map((t) => {
        const active = isRouteActive(t, pathname);
        return (
          <Link key={t.id} to={t.path} className={`tab${active ? ' tab-active' : ''}`} aria-current={active ? 'page' : undefined} title={t.description}>
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default PageTabs;
